import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import Field from '../../../../../../../components/Form/Field'
import Form from '../../../../../../../components/Form'

import { usePurifiedFormik } from '../../../../../../../hooks/formHooks/usePurifiedFormik'

import { createRight, clearCreateRight } from '../../../../../../../modules/actions/rights'
import {
  createdRightErrorSelector,
  createdRightIsLoadingSelector,
  rightWasCreatedSelector
} from '../../../../../../../modules/selectors/rights'
import {
  selectedPartnershipCurrency,
  selectedPartnershipSelector
} from '../../../../../../../modules/selectors/partnerships'

import { DIGITAL_RIGHT_CREATE } from '../../../../../../../constants/forms'
import { BUDGET, NAME } from '../../../fields'

import { validationSchema } from './validation'
import { initialValues } from './fields'
import { transformValuesToBE } from './formatters'

import useDrawerFormClasses from '../../../../../../../styles/common/drawerForms'

const ShortDigitalRightCreateForm = () => {
  const drawerFormClasses = useDrawerFormClasses()

  const dispatch = useDispatch()

  const rightWasCreated = useSelector(rightWasCreatedSelector)
  const { currency_symbol: currencySymbol } = useSelector(selectedPartnershipCurrency)
  const { id: partnershipId } = useSelector(selectedPartnershipSelector)

  const onSubmit = useCallback(
    values => {
      const transformedData = transformValuesToBE(values)

      dispatch(
        createRight({
          ...transformedData,
          partnership: partnershipId
        })
      )
    },
    [dispatch, partnershipId]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const clearCreateRightSubmit = useCallback(() => dispatch(clearCreateRight()), [dispatch])

  return (
    <Form
      formik={purifiedFormik}
      formName={DIGITAL_RIGHT_CREATE}
      successSubmit={rightWasCreated}
      errorSelector={createdRightErrorSelector}
      isLoadingSelector={createdRightIsLoadingSelector}
      clearHandler={clearCreateRightSubmit}
    >
      <section className={drawerFormClasses.section}>
        <h3 className={drawerFormClasses.sectionTitle}>Campaign name</h3>
        <Field formik={formik} id={NAME} name={NAME} placeholder="Name of campaign" />
      </section>
      <section className={drawerFormClasses.section}>
        <h3 className={drawerFormClasses.sectionTitle}>Budget</h3>
        <p>A maximum budget that can be spread across the different ad platforms.</p>
        <Field
          placeholder="Budget"
          type="number"
          formik={formik}
          name={BUDGET}
          symbol={currencySymbol}
          enableReinitialize
          inputMode="numeric"
        />
      </section>
    </Form>
  )
}

export default ShortDigitalRightCreateForm
